var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDetail = function SvgDetail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17",
    stroke: "#263360",
    strokeLinecap: "round",
    strokeWidth: 1
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICO_DETAIL",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 6,
    cy: 6,
    r: 6,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M17.2,20.581l3.737,3.761a1.893,1.893,0,0,0,2.754,0h0a1.921,1.921,0,0,0,0-2.771L20.937,18.8",
    transform: "translate(-8.281 -8.936)",
    fill: "none",
    stroke: "#263360",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_96",
    "data-name": "Line 96",
    y2: 5,
    transform: "translate(6 3.5)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259",
    transform: "translate(12) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_96-2",
    "data-name": "Line 96",
    y2: 5,
    transform: "translate(6 3.5)",
    fill: "none"
  })))));
};
export default SvgDetail;